import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "q4hob60w",
    dataset: "production"
})